import { z } from 'zod';
import { FlowDurationSchema } from '../../../../duration/duration.js';
import { BaseFlowBlockSchema } from '../../block.js';
import { FlowBlockType } from '../../type.js';
export const FlowWaitBlockV2Schema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.WaitV2),
    config: z
        .object({
        duration: FlowDurationSchema.optional(),
        waitUntilDate: z.string().optional(),
        jitter: FlowDurationSchema.optional(),
    })
        .refine((obj) => 
    // We only allow one of these fields, (XOR):
    Boolean(obj.duration) !== Boolean(obj.waitUntilDate), {
        message: 'Either pre-defined duration or dynamic duration/target datetime must be provided (but not both)',
        path: ['duration', 'waitUntilDate'],
    }),
});
//# sourceMappingURL=config.js.map